<template>
  <v-dialog :value="value" persistent max-width="460px">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon class="mr-2">mdi-lock-clock</v-icon>
        Entre novamente
      </v-card-title>
      <v-card-text>
        <p class="mb-4">
          Sua sessão expirou ou foi desconectada. Entre novamente para continuar
          exatamente de onde parou.
        </p>
        <v-alert v-if="errorMessage" type="error" dense text>
          {{ errorMessage }}
        </v-alert>
        <v-form ref="form" @submit.prevent="login">
          <template v-if="isSupportSession">
            <v-text-field
              v-model="supportUserId"
              filled
              hide-details="auto"
              label="ID do usuário destino *"
              type="number"
              :rules="[$rules.required]"
              :disabled="loading"
            />
            <div class="text-caption mb-3">Sessão anterior: {{ supportTarget }}</div>
            <v-text-field
              v-model="secret"
              filled
              hide-details="auto"
              label="Chave de suporte *"
              :type="showSecret ? 'text' : 'password'"
              :append-icon="showSecret ? 'mdi-eye-off' : 'mdi-eye'"
              :rules="[$rules.required]"
              :disabled="loading"
              @click:append="showSecret = !showSecret"
            />
          </template>
          <template v-else>
            <v-text-field
              v-model="username"
              filled
              hide-details="auto"
              label="Código do associado ou CPF *"
              :rules="[$rules.required]"
              :disabled="loading"
            />
            <v-text-field
              v-model="password"
              filled
              hide-details="auto"
              label="Senha *"
              type="password"
              :rules="[$rules.required]"
              :disabled="loading"
            />
          </template>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text :disabled="loading" @click="$emit('exit')">
          Sair
        </v-btn>
        <v-spacer />
        <v-btn color="primary" :loading="loading" @click="login">
          Entrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReauthenticationDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    username: '',
    supportUserId: '',
    password: '',
    secret: '',
    showSecret: false,
    loading: false,
    errorMessage: '',
  }),
  computed: {
    currentUser() {
      return this.$store.state.user || {};
    },
    isSupportSession() {
      return this.currentUser.is_support === true;
    },
    supportTarget() {
      const name = this.currentUser.name || 'Usuário';
      return `${name} (ID ${this.currentUser.id})`;
    },
  },
  watch: {
    value(required) {
      if (!required) {
        return;
      }
      this.username = this.currentUser.cpf || '';
      this.supportUserId = this.currentUser.id || '';
      this.password = '';
      this.secret = '';
      this.errorMessage = '';
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
  },
  methods: {
    async login() {
      if (this.loading || !this.$refs.form || !this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      this.errorMessage = '';
      try {
        const previousUserId = Number(this.currentUser.id || 0);
        let sameUser = true;
        if (this.isSupportSession) {
          const userId = Number(this.supportUserId);
          const response = await this.$axios.patch('/accounts/support/create-token', {
            user_id: userId,
            secret: this.secret,
            ...this.$utils.loginDeviceData(),
          });
          sameUser = previousUserId === userId;
          this.$store.commit('setSupportToken', response.data);
        } else {
          const response = await this.$axios.post('/login', {
            username: this.username,
            password: this.password,
            ...this.$utils.loginDeviceData(),
          });
          sameUser = previousUserId > 0 && Number(response.data.id) === previousUserId;
          if (sameUser) {
            this.$store.commit('setUser', response.data);
          }
        }
        this.password = '';
        this.secret = '';
        this.$emit('authenticated', sameUser);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.errorMessage = 'Senha incorreta.';
        } else if (error.response && error.response.status === 404) {
          this.errorMessage = 'Usuário não encontrado.';
        } else {
          this.errorMessage = this.isSupportSession
            ? 'Chave de suporte inválida.'
            : 'Não foi possível renovar sua sessão.';
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
